import { DialogBox } from "lib/@components/dialogBox"
import { Typography } from "@mui/material"
import { useState } from "react"
import { AuthoringEditor } from "authoring/components/authoring-editor"

export function RejectReviewDialog() {
    const [rejectionSummary, setRejectionSummary] = useState("")

    return (
        <DialogBox
            title="Reject Review"
            okCaption="Reject Draft"
            okColor="error"
            value={{
                rejectionSummary: rejectionSummary.trim(),
            }}
            data-cy="reject-review-dialog"
        >
            <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                Rejecting this draft will set its status to Rejected so the author can revise and re-submit it for
                review.
            </Typography>
            <AuthoringEditor
                value={rejectionSummary}
                onChange={setRejectionSummary}
                autoFocus
                label="Rejection Summary (Optional)"
                placeholder="Add high-level notes to help the author revise this draft..."
                workplaceMaxHeight={240}
            />
        </DialogBox>
    )
}
